<a (click)="go()" class="m-brand__logo-wrapper">
    <img [attr.src]="headerLogo" [ngClass]="{'m--margin-top-5': locationIcon === 'config.aside.top.skin'}"
         alt="OCTOPAI Logo"/>
</a>
